import template from './checkboxFormElement.html';
import controller from './checkboxFormElement.controller';
import './checkboxFormElement.scss';

let checkboxFormElementComponent = {
  restrict: 'E',
  bindings: {
    value: '=',
    disabled: '<',
    option: '<',
    label: '@'
  },
  template,
  controller
};

export default checkboxFormElementComponent;
